import { render, staticRenderFns } from "./Subsidiary.vue?vue&type=template&id=f55f6c68&scoped=true"
import script from "./Subsidiary.vue?vue&type=script&lang=js"
export * from "./Subsidiary.vue?vue&type=script&lang=js"
import style0 from "./Subsidiary.vue?vue&type=style&index=0&id=f55f6c68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55f6c68",
  null
  
)

export default component.exports